<template>
    <div class="tab-content default text-center">
        <div class="" id="" role="tabpanel" aria-expanded="true">
            <div class="container no-padding-right">
                <ul class="row listing-items">
                    <li v-for="product in products" class="col-xl-3 col-lg-4 col-md-6 col-12 no-padding">
                        <div class="product-box" style="position:relative">
                            <span class="discount" v-if="product.DiscountPercent != 0 && product.Price != 0 && product.IsAvailable">{{product.DiscountPercent}} %</span>
                            <router-link class="product-box-img" :title="product.Name"  :to="product.RedirectLink != null   ? { name: 'product' , params: { productId: product.Id , productName: product.RedirectLink.replace(/\//g, '-').replace(/\*/g, '-').replace(/\s+/g, '-') } } : { name: 'product' , params: { productId: product.Id , productName: product.Name.replace(/\//g, '-').replace(/\*/g, '-').replace(/\s+/g, '-') } }">
                                <img :src="product.PicPath" @error="imageLoadOnError" :alt="product.AltPicPath" :title="product.Name">
                            </router-link>
                            <div class="product-box-content">
                                <div class="product-box-content-row">
                                    <div class="product-box-title">
                                        <router-link :title="product.Name" :to="product.RedirectLink != null   ? { name: 'product' , params: { productId: product.Id , productName: product.RedirectLink.replace(/\//g, '-').replace(/\*/g, '-').replace(/\s+/g, '-') } } : { name: 'product' , params: { productId: product.Id , productName: product.Name.replace(/\//g, '-').replace(/\*/g, '-').replace(/\s+/g, '-') } }">
                                            {{ product.Name }}
                                        </router-link>
                                    </div>
                                </div>
                                <div class="product-box-row product-box-row-price">
                                    <div class="price">
                                        <div class="price-value">
                                            <div class="price-value-wrapper">
                                                <div class="price-div-hd" v-if="product.Price != 0">
                                                    <div v-if="product.IsAvailable">
                                                        <div><span>{{   parseInt(product.Price - ((product.Price * product.DiscountPercent) / 100))   | formatNumber }} </span><span class="price-currency">تومان</span></div>
                                                        <div v-if="product.DiscountPercent != 0" class="dis-price-liner">
                                                            <span>{{ product.Price | formatNumber}} </span>
                                                            <span class="price-currency">تومان</span>
                                                        </div>
                                                    </div>
                                                    <div v-else>
                                                        <span class="unAvailable">ناموجود</span>
                                                    </div>
                                                </div>
                                                <div v-else>
                                                    <div class="callToMain">
                                                        <span class="call">جهت استعلام قیمت تماس بگیرید</span>
                                                    </div>
                                                </div>
                                               
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                          
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    import { filterEventBus } from "../../eventBus/eventBus";
    export default {
        data() {
            return {
                products: [],
            }
        },
        methods: {
            imageLoadOnError(event) {

                event.target.src = "/assets/img/no-image-available.png";
            },
        },
        computed: {
            
        },
        created() {
            filterEventBus.$on('productViewer', (value) => {
                this.products = value;
            });
        },
        beforeDestroy() {
            filterEventBus.$off('productViewer');
        }
    }
</script>

<style scoped>
    .product-box .discount{
    content: '';
    width: 55px;
    height: 35px;
    background-color: #ef5662;
    color: #fff;
    top: 20px;
    left: 15px;
    position: absolute;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    font-weight: bold;
    border-radius: 40px;
    z-index: 9999;
    font-size: 16px;
}
    .unAvailable:after {
        width: 100%;
        top: 8px;
        left: 58px;
    }
    .unAvailable:before {
        width: 100%;
        top: 8px;
        right: 58px;
    }
    .call {
        font-size: 13px;
    }
    .callToMain {
        margin-bottom: unset;
    }
        .price-value-wrapper {
        text-align:center;
    }
    .price-div-hd {
        position:relative;
        display: inline-block;
    }
    .price .price-value .price-value-wrapper {
        position: relative;
    }

        .price .price-value .price-value-wrapper .dis-price-liner {
            position: absolute;
            color: #979898;
            font-size: 15px;
            top: -18px;
            width:100%;
            /*right: 50px;*/
        }

            .price .price-value .price-value-wrapper .dis-price-liner:after {
                content: '';
                border-top: 1px solid #979898;
                -webkit-transform: rotate(20deg);
                transform: rotate(0deg);
                width: 80%;
                display: block;
                position: relative;
                top: -8px;
                left: -10px;
            }

    .search-page .price {
        display: block;
    }

    .price-value {
        float: unset;
    }

    .price-value-wrapper {
        text-align: center;
    }

    .product-box {
        padding: 26px 20px 15px;
    }

    .product-box-row {
        display: block;
    }

    .product-box-row-price {
        margin-top: 35px;
    }

    .discount-box {
        position: relative;
    }

        .discount-box .discount {
            content: '';
            width: 55px;
            height: 35px;
            background-color: #ef5662;
            color: #fff;
            top: 20px;
            left: 15px;
            position: absolute;
            display: flex;
            justify-content: center;
            align-items: center;
            font-weight: bold;
            border-radius: 40px;
            z-index: 1;
            font-size: 16px;
        }
         @media only screen and (min-width: 0px) and (max-width: 640px) {
        .product-box .discount {
            width: 44px;
            height: 25px;
            top: 7px;
            left: 1px;
            font-size: 13px;
        }
    }
</style>